import CloseIcon from '../../../assets/icons/close.svg?react';
import { useDeleteReportRequest } from '../../../hooks/queries/reportQueries';
import { useState } from 'react';
import dayjs from 'dayjs';
const ReportDeleteModal = ({ onClose, report, onDeleteSuccess }) => {
  const deleteReport = useDeleteReportRequest();
  const [isPending, setIsPending] = useState(false);
  const handleDelete = async () => {
    setIsPending(true);
    try {
      await deleteReport.mutateAsync(report.ReportRequestSysId);
      onDeleteSuccess();
    } catch (error) {
      console.error('보고서 삭제 실패:', error);
      alert('보고서 삭제에 실패했습니다.');
    } finally {
      setIsPending(false);
    }
  };
  return (
    <div className="modal-background">
      <div className="modal-container">
        <div className="modal-header">
          <h3>보고서 삭제</h3>
          <button className="close-btn" onClick={onClose}>
            <CloseIcon />
          </button>
        </div>
        <div className="modal-content">
          <p className="text-b2-400 text-gray-800 my-10">보고서를 삭제하시겠습니까?</p>
          <table className='gray-table'>
            <tr>
              <th>보고서명</th>
              <td>{report.ReportTitle || '-'}</td>
            </tr>
            <tr>
              <th>요청시간</th>
              <td>{report.RequestedAt ? dayjs(report.RequestedAt).format('YYYY-MM-DD HH:mm:ss') : '-'}</td>
            </tr>
            <tr>
              <th>종료시간</th>
              <td>{report.CompletedAt ? dayjs(report.CompletedAt).format('YYYY-MM-DD HH:mm:ss') : '-'}</td>
            </tr>
            <tr>
              <th>템플릿</th>
              <td>{report.templateName || '-'}</td>
            </tr>
          </table>
        </div>
        <div className="modal-footer">
          <button className="btn big-btn btn-primary" onClick={handleDelete} disabled={isPending}>{isPending ? '삭제 중...' : '삭제'}</button>
        </div>
      </div>
    </div>
  )
}

export default ReportDeleteModal